"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _utils = require("../utils");

var _lodash = _interopRequireDefault(require("lodash"));

var _fullscreenEvents = _interopRequireDefault(require("../constants/fullscreenEvents"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var FullscreenBottomMobileBar = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(FullscreenBottomMobileBar, _React$Component);

  function FullscreenBottomMobileBar(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;
    _this.state = {};
    return _this;
  }

  var _proto = FullscreenBottomMobileBar.prototype;

  _proto.render = function render() {
    var _this2 = this;

    var curItem = _lodash["default"].get(this.props, 'item') || _lodash["default"].get(this.props, 'current.item');

    var titleText = _utils.utils.getTitleOrFilename(curItem.title, curItem.fileName) || '';
    var title = titleText && this.props.styleParams.allowTitleExpand ? /*#__PURE__*/_react["default"].createElement("div", {
      className: "fullscreen-side-bar-title"
    }, titleText) : '';
    var descriptionText = curItem.description || '';
    var descriptionTextArray = descriptionText.split('\n');
    var description;

    if (descriptionText && this.props.styleParams.allowDescriptionExpand) {
      var descriptionElementsArray = [];

      for (var i = 0; i < descriptionTextArray.length; i++) {
        descriptionElementsArray.push( /*#__PURE__*/_react["default"].createElement("div", {
          className: "fullscreen-side-bar-description-line",
          key: 'description_' + i
        }, descriptionTextArray[i]));
      }

      description = /*#__PURE__*/_react["default"].createElement("div", {
        className: "fullscreen-side-bar-description"
      }, descriptionElementsArray);
    } else {
      description = '';
    }

    var linkClassNames = 'fullscreen-side-bar-link pro-fullscreen-link pro-fullscreen-store';
    var link = curItem.hasLink && this.props.styleParams.allowLinkExpand ? curItem.linkType === 'web' ? /*#__PURE__*/_react["default"].createElement("a", {
      className: linkClassNames,
      href: !curItem.isWixUrl && curItem.linkUrl,
      onClick: function onClick() {
        return curItem.isWixUrl && _this2.props.actions.eventsListener(_fullscreenEvents["default"].NAVIGATE, curItem);
      },
      target: curItem.linkOpenType
    }, curItem.linkText || curItem.linkUrl) : /*#__PURE__*/_react["default"].createElement("div", {
      className: linkClassNames,
      onClick: function onClick() {
        return _this2.props.actions.eventsListener(_fullscreenEvents["default"].NAVIGATE, curItem);
      }
    }, curItem.linkText || curItem.linkUrl) : '';
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: 'fullscreen-bottom-mobile-info pro-fullscreen-store',
      style: {
        textAlign: this.props.styleParams.galleryAlignExpand
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: 'fullscreen-side-bar-info-container pro-fullscreen-store'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      ref: function ref(itemContainer) {
        _this2.itemContainer = itemContainer;
      }
    }, title, description), link));
  };

  return FullscreenBottomMobileBar;
}(_react["default"].Component);

var _default = FullscreenBottomMobileBar;
exports["default"] = _default;